var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"see",class:_vm.transitionShow},[_c('video',{attrs:{"id":"myVideo","muted":"","loop":"","playsinline":""},domProps:{"muted":true}}),_c('canvas',{attrs:{"id":"myCanvas","width":"200"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }